import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Loader from '@amzn/meridian/loader'
import Column from '@amzn/meridian/column'
import { getParameterByName, EnvironmentDetail, CountMetric } from '@amzn/ihm-associate-tools-js-lib'
import { IIBServiceClient } from '@api/IIBServiceClient'
import { IhmLoginServiceClient } from '@api/IhmLoginServiceClient'
import { IhmLoginTokenProvider } from '@api/utils/IhmLoginTokenProvider'
import { IIBTokenProvider } from '@api/utils/IIBTokenProvider'
import { UserTypeService } from '@pages/UserTypeSelection/utils/UserTypeService'
import { StoreIdService } from '@pages/StoreIdSelection/utils/StoreIdService'
import { DorothyUtils } from '@utils/DorothyUtils'
import { LogoutUtils } from '@pages/LogoutPage/utils/LogoutUtils'
import { featureConfigFeatures, isFeatureEnabled } from '@services/FeatureConfigService'

const LogoutPage = () => {
    const navigate = useNavigate()

    useEffect(() => {
        // TODO: Add globalEventBus.publish(SeawardEventBusTopics.LOGOUT)
        const primaryStore = EnvironmentDetail.getStoreId()
        const iibLogin = EnvironmentDetail.isIIBAuthN() && !!EnvironmentDetail.getLoginType()
        const isIIBEnabled = isFeatureEnabled(featureConfigFeatures.ENABLE_IIB,false)
        // Log out of IhmLogin on Android or if AuthNType in the URL query parameter is 'ihm-login'.
        // Context: https://sim.amazon.com/issues/IHM-AP-2545
        if (EnvironmentDetail.isIhmIdentityBrokerAuthN()) {
            console.log('ATBase: Redirecting to login page')
            navigate('/login')
            return
        } else if (iibLogin && isIIBEnabled) {
            // IIB does not allow redirection to fragmented urls and hence would redirect to the main page of ATB
            const storedState = window.localStorage.getItem(IIBServiceClient.IIB_STATE_LOCAL_STORAGE_KEY)
            if (storedState && storedState === getParameterByName('state')) {
                window.localStorage.removeItem(IIBServiceClient.IIB_STATE_LOCAL_STORAGE_KEY)
                navigate('/login/')
            } else {
                const IIBLogout = async () => {
                    try {
                        const isTokenSet = await IIBTokenProvider.isTokenSet()
                        const bypassLogout = !!DorothyUtils.getDorothyStoreInfo(primaryStore) &&
                        !UserTypeService.getUserType() && !isTokenSet
                        await LogoutUtils.emitLogoutAssociateAuditTrailEventIfRequired(primaryStore)
                        IhmLoginTokenProvider.clear()
                        if (!bypassLogout) {
                            UserTypeService.resetIsWfmLogin()
                            IIBTokenProvider.clear()
                            if (DorothyUtils.getDorothyStoreInfo(primaryStore) !== undefined) {
                                UserTypeService.resetUserType()
                                StoreIdService.resetStoreIdService()
                                navigate('/user-type-selection')
                            } else {
                                IIBServiceClient.login()
                            }
                        } else {
                            console.log('ATBase: logout bypassed for dorothy redirecting to user selection')
                            navigate('/user-type-selection')
                            return
                        }
                    } catch (error) {
                        console.error('Error executing prelogin steps',error)
                    }
                }
                IIBLogout()
            }
        } else {
            IhmLoginTokenProvider.isTokenSet()
                .then((isTokenSet) => {
                    // Do not log out on first load for a Dorothy store
                    // Heuristic is that the store is Dorothy-enabled, but no user type has been selected and there's no login
                    // token set.
                    if (EnvironmentDetail.isIIBAuthN() && !EnvironmentDetail.getLoginType()) {
                        new CountMetric(EnvironmentDetail.getStoreId(), 'IIBAuthError', 'IhmFlyingDutchman', 'missingLoginType').count(1)
                    }
                    const bypassLogout = !!DorothyUtils.getDorothyStoreInfo(primaryStore) &&
                    !UserTypeService.getUserType() &&
                    !isTokenSet
                    if (EnvironmentDetail.isIIBAuthN()) {
                        LogoutUtils.emitLogoutAssociateAuditTrailEventIfRequired(primaryStore)
                        .finally(() => {
                            if (!bypassLogout) {
                                console.log('ATBase: deviceRegistryService initiating logout sequence')
                                LogoutUtils.onLogoutDeregisterDevice()
                                    .catch((error) => {
                                        console.error('ATBase: LogoutController: deviceRegistryService logout sequence failed. ', JSON.stringify(error))
                                    }).finally(() => {
                                        IIBTokenProvider.clear()
                                        IhmLoginTokenProvider.clear()
                                        if (DorothyUtils.getDorothyStoreInfo(primaryStore) !== undefined) {
                                            UserTypeService.resetUserType()
                                            StoreIdService.resetStoreIdService()
                                        }
                                        const keepUsernameParamValue = getParameterByName('keep_username')
                                        const keepUsername = keepUsernameParamValue ? keepUsernameParamValue.toLowerCase() === 'true' : true
                                        IhmLoginServiceClient.logout(keepUsername)
                                    })
                                return
                            } else {
                                console.log('ATBase: logout bypassed for dorothy redirecting to user selection')
                                navigate('/user-type-selection')
                                return
                            }
                        })
                    } else navigate('/provision')
                })
        }
    }, [])

    return (
        <Column alignmentHorizontal={'center'} spacing={'medium'} spacingInset="medium">
            <Loader type="circular" size="medium"/>
        </Column>
    )
}

export default LogoutPage
